import { emDash } from '@/presentation/utils/text';
import { useFormatter } from 'use-intl';

interface TickSectionProps {
  tickLowerValue?: number | null;
  tickUpperValue?: number | null;
}

export const TickItem = ({ tick }: { tick: number }) => {
  const { number } = useFormatter();

  return (
    <>
      {
        number(tick, {
          maximumFractionDigits: 4,
        }) as `${number}`
      }
    </>
  );
};

export const TickSection = ({
  tickLowerValue,
  tickUpperValue,
}: TickSectionProps) => {
  if (!tickLowerValue || !tickUpperValue) return null;

  return (
    <span className="ml-2">
      {'['}
      <TickItem tick={tickLowerValue} />
      {emDash}
      <TickItem tick={tickUpperValue} />
      {']'}
    </span>
  );
};
